import { createBrowserRouter } from 'react-router-dom';

import protectedRoutes from './protected';
import authRoutes from './auth';

const router = createBrowserRouter([authRoutes, protectedRoutes], {
  basename: process.env.REACT_APP_BASE_NAME,
});

export default router;
